import PropTypes from "prop-types"
import React from "react"

import { Container } from "./styled"

export const ErrorMessage = ({ children, className }) => <Container className={className}>{children}</Container>

ErrorMessage.propTypes = {
  children: PropTypes.node,
}
